// 用于动态模版渲染
export const isSelectMany = (val) => isSelect(val) || isMultiSelect(val)
export const isNeedRangeLengthMany = (val) => isInput(val) || isSingleLineInput(val) || isTextarea(val)

export const isInputMany = (val) => isInput(val) || isSingleLineInput(val) || isIdentityInput(val) || isPhoneInput(val) || isEmailInput(val) || isQQInput(val) || isMailInput(val)

// 1 单选选择框
export const isSelect = (val) => +val === 1

// 2 短文本框
export const isInput = (val) => +val === 2

// 3 身份证件号
export const isIdentityInput = (val) => +val === 3

// 4 单行文本框
export const isSingleLineInput = (val) => +val === 4

// 5 树形选择框
export const isCascader = (val) => +val === 5

// 6 数字
export const isInputNumber = (val) => +val === 6

// 7 多行文本框
export const isTextarea = (val) => +val === 7

// 8 手机号
export const isPhoneInput = (val) => +val === 8

// 9 附件
export const isUpload = (val) => +val === 9

// 10 多选选择框
export const isMultiSelect = (val) => +val === 10

// 11 富文本框
// export const isQuillEditor = (val) => +val === 11

// 12 日期选择框
export const isDatePicker = (val) => +val === 11

// 13 邮政编码
export const isEmailInput = (val) => +val === 12

// 13 QQ
export const isQQInput = (val) => +val === 13

// 14 邮箱
export const isMailInput = (val) => +val === 14

export const isFieldRow = (val) => isTextarea(val) || isSingleLineInput(val) || isUpload(val)
